//Localhost
export const LOCALHOST = process.env.REACT_APP_URL_LOCAL;

//Auth
export const SIGNIN = '/';
export const SIGNUP = '/signup';
export const EXPIRATIONTOKEN = '/expirationtoken';
export const PAGENOTFOUND = '/*';

//Home
export const HOME = '/home';

//Cases
export const CASES = '/cases';
export const CASEMANAGEMENTLIST = '/cases/managementlist';
export const CASEMANAGERBULKLOAD = '/cases/bulkload';
export const CASEMANAGERLIST = '/cases/managerlist';
export const CASEREPORT = '/cases/casereport';
export const CASECLOSURE = '/cases/caseclosure';
export const CASECREATION = '/cases/casecreation';
export const CASEOTRS = '/cases/casotrs';
export const USERSCREATION = '/cases/usercreation';
export const IVR_TYPIFICATION_BASE = '/cases/ivr-typification-base';

//Activity Times
export const ACTIVITYTIMES = '/activitytimes';
export const ACTIVITYTILIST = '/activitytimes/list';
export const ACTIVITYTIMESEXPORT = '/activitytimes/export';

//We Call You Admin
export const WECALLYOUADMIN = '/wecallyouadmin';

//Surveys
export const SURVEYS = '/surveys';
export const SURVEYLIST = '/surveys/list';
export const SURVEYNEW = '/surveys/new';
export const SURVEYEDIT = '/surveys/edit';
export const SURVEYQUESTIONS = '/surveys-questions';

//Templates
export const TEMPLATES_WSP = '/template-wsp';
export const TEMPLATES_WSP_EDIT = '/template-wsp/edit';
export const TEMPLATES_WSP_NEW = '/template-wsp/new';

//Users
export const USERS = '/users';
export const USERLIST = '/users/list';
export const USERNEW = '/users/new';
export const USEREDIT = '/users/edit';

//Block Pages
export const BLOCKPAGES = '/blockpages';

//Chat
export const CHAT = '/chat';

//Video Call
export const VIDEOCALL = '/videocall';

//We Call you
export const WECALLYOU = '/we-call-you';

//Video Call
export const VIDEOATENTION = '/videoatencion';

//Cases
export const COMMERCIAL_CRM = '/commercial-crm';
export const COMMERCIAL_CRM_LOAD_BASE_BP = `${COMMERCIAL_CRM}/load-base-bp`;
export const COMMERCIAL_CRM_LOAD_BASE_GUPSHUP = `${COMMERCIAL_CRM}/load-base-gupshup`;
export const COMMERCIAL_CRM_LOAD_BASE_GUPSHUP_CUSTOM = `${COMMERCIAL_CRM}/load-base-gupshup-custom`;
//Voice Blaster
export const VOICE_BLASTER = '/voice-blaster';

//IVR
export const IVR = '/ivr';
